import axios from "@/api/axiosInstance";
import {
  SaveCatalogCategoryRequest,
  SaveCatalogCategoryResponse,
} from "./types";

export const updateCatalogCategory = async (
  id: string,
  payload: SaveCatalogCategoryRequest,
): Promise<SaveCatalogCategoryResponse> => {
  const response = await axios.put<SaveCatalogCategoryResponse>(
    `/api/private/product-catalog/categories/${id}`,
    payload,
  );
  return response.data;
};
